import { ethers } from "ethers";
import { useState } from "react";
import { useWallet } from "../context/WalletContext";
import axios from 'axios';
import {ABI, SERVER_URL, TOKENSALE_ADDRESS} from '../utils/constants'
import { toast } from "react-toastify";

export const sendCoin = async (
  recipient: string,
  amount: string 
): Promise<string | null> => {
  if (!window.ethereum) {
    toast.error('MetaMask is not installed!');
    return null;
  }

  try {
    const provider = new ethers.BrowserProvider(window.ethereum);
    const signer = await provider.getSigner(); // Get user wallet
    const tx = await signer.sendTransaction({
      to: recipient,
      value: ethers.parseEther(amount), // Convert amount to Wei
    });
    
    await tx.wait(); // Wait for confirmation
    toast.success(`You've successfully purchased $HYPER tokens! `);


    return tx.hash;
    
  } catch (error: any) {
    console.log(error.code)
    toast.error(`Insufficient funds`);
    return null;
  }
};


export const BuyTokenBonus = async (
  recipient: string,
  amount: string,
  address: string
): Promise<string | null> => {
  if (!window.ethereum) {
    toast.error('MetaMask is not installed!');
    return null;
  }

  try {
    const provider = new ethers.BrowserProvider(window.ethereum);
    const signer = await provider.getSigner();
    const contract = new ethers.Contract(recipient, ABI, signer);
    
   
    const tx = await contract.buyTokens(address, {
      value: ethers.parseEther(amount) 
    });

    const receipt = await tx.wait();

    toast.success(`You've successfully purchased $HYPER tokens! `);
    return receipt.hash;
    
  } catch (error) {
    console.log(error)
    
    toast.error(`Transaction failed. Please try again.`);
    return null;
  }
};
